import { Component, Vue, PropSync, Emit, Watch } from 'vue-property-decorator';
import { TableSubSectionFilter } from '@/models/tables/TableSubSectionFilter';

@Component
export default class SubSectionSelectComponent extends Vue {
    @PropSync('data', { type: Array }) public syncedData!: TableSubSectionFilter[];
    @PropSync('selected', { type: String }) public syncedSelected!: string;
    @PropSync('titleId', { type: String }) public syncedTitleId!: string;
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    @PropSync('small', { type: Boolean }) public syncedSmall!: boolean;

    public selectSubSectionValue: string = '';
    public selectSubSectionValueIndex: number = 0;
    public disableBackward: boolean = true;
    public disableForward: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.disableBackward = this.selectSubSectionValueIndex <= 0;
        this.disableForward = this.selectSubSectionValueIndex >= this.syncedData.length - 1;
        this.selectSubSectionValue = this.syncedSelected;
    }

    public updated() {
        this.disableBackward = this.selectSubSectionValueIndex <= 0;
        this.disableForward = this.selectSubSectionValueIndex >= this.syncedData.length - 1;
    }

    @Emit()
    public sectionChanged(inSectionIdentifier: string): string {
        return inSectionIdentifier;
    }

    @Watch('syncedSelected')
    public onSyncedSelectedChanged(newValue: string) {
        if (this.selectSubSectionValue !== newValue) {
            this.selectSubSectionValue = newValue;
            this.selectSubSectionValueIndex = 0;
            this.disableBackward = this.selectSubSectionValueIndex <= 0;
            this.disableForward = this.selectSubSectionValueIndex >= this.syncedData.length - 1;
        }
    }

    public onSubSectionChanged() {
        this.selectSubSectionValueIndex = this.syncedData.findIndex((x) => x.value === this.selectSubSectionValue);
        this.sectionChanged(this.selectSubSectionValue);
    }

    public onSubSecBackward() {
        let index = this.syncedData.findIndex((x) => x.value === this.selectSubSectionValue);
        this.setSelectedIndex(--index);
    }

    public onSubSecForward() {
        let index = this.syncedData.findIndex((x) => x.value === this.selectSubSectionValue);
        this.setSelectedIndex(++index);
    }

    public setSelectedIndex(inIndex: number) {
        if (inIndex < 0) {
            this.selectSubSectionValueIndex = 0;
        } else {
            this.selectSubSectionValueIndex = inIndex >= this.syncedData.length ? this.syncedData.length - 1 : inIndex;
        }
        this.selectSubSectionValue = this.syncedData[this.selectSubSectionValueIndex].value;
        this.sectionChanged(this.selectSubSectionValue);
    }
}
